import {FieldMaxLength} from '~/types/FieldMaxLength'

export const useFieldMaxLength = (length: FieldMaxLength): number => {
  return Number(length)
}
